import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const location = useLocation();


    useLayoutEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }, [location.pathname, location.search]);

    return null;
}

export default ScrollToTop;